module.exports = __webpack_public_path__ + "static/media/item-10.71cf41df.png";